// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__25Z-J","meals-appear":"AvailableMeals_meals-appear__1GyLG","mealsloading":"AvailableMeals_mealsloading__3OyfS","error":"AvailableMeals_error__3RKUE"};